import { render, staticRenderFns } from "./ModalAtestoRegistroEntrada.vue?vue&type=template&id=48c87765&scoped=true"
import script from "./ModalAtestoRegistroEntrada.vue?vue&type=script&lang=js"
export * from "./ModalAtestoRegistroEntrada.vue?vue&type=script&lang=js"
import style0 from "./ModalAtestoRegistroEntrada.vue?vue&type=style&index=0&id=48c87765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c87765",
  null
  
)

export default component.exports